import { posSettingsSchema } from "@redotech/redo-return-settings-common/pos-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updatePosSettings = {
  name: "updatePosSettings" as const,
  input: z.object({ teamId: zExt.objectId(), settings: posSettingsSchema }),
  output: z.object({}),
};
